import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "10.2",
  fill: "none",
  viewBox: "0 0 20 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-ai-gateway-brand))",
      d: "M3.333 11.5a2.4 2.4 0 0 1-1.77-.73A2.4 2.4 0 0 1 .832 9q0-1.042.73-1.771a2.4 2.4 0 0 1 1.77-.73V4.834q0-.687.49-1.177.489-.49 1.177-.49h2.5q0-1.041.729-1.77a2.4 2.4 0 0 1 1.77-.73 2.4 2.4 0 0 1 1.771.73q.73.729.73 1.77H15q.687 0 1.177.49t.49 1.177V6.5q1.041 0 1.77.729a2.4 2.4 0 0 1 .73 1.77 2.4 2.4 0 0 1-.73 1.772 2.4 2.4 0 0 1-1.77.729v3.333q0 .687-.49 1.177T15 16.5H5q-.688 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177zM7.5 9.833q.52 0 .885-.364.365-.365.365-.886 0-.52-.365-.885a1.2 1.2 0 0 0-.885-.365q-.522 0-.886.365a1.2 1.2 0 0 0-.364.885q0 .521.364.886.364.364.886.364m5 0q.52 0 .885-.364.365-.365.365-.886 0-.52-.365-.885a1.2 1.2 0 0 0-.885-.365q-.522 0-.886.365a1.2 1.2 0 0 0-.364.885q0 .521.364.886.364.364.886.364m-5.834 3.333h6.667V11.5H6.666zM5 14.833h10v-10H5z"
    }, null, -1)
  ]))]))
}
export default { render: render }